<template>
  <div id="app">
    <tanitimMail ref="tanitimdialog" :servisTipi="2"></tanitimMail>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <!-- <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingdialog"></loadingcomp> -->
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <hotelloadingcomp ref="hotelloadingcomp" iconname="rv_hookup" v-bind:mesaj="loadingmesaj" v-model="loadingdialog">
    </hotelloadingcomp>

    <!-- Cari Ödeme Onay Dialogu -->
    <v-dialog v-model="cariDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('Payment-Confirmation') }}</v-card-title>
        <v-card-text v-html="$t('Transfer-Current-Payment-Confirm', { price: TransferResult.PriceDetails.UserPrice })">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cariDialog = false">{{ $t('cancel_button') }}</v-btn>
          <v-btn color="green darken-1" text @click="confirmCariPayment">{{ $t('Approve') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Kredi Kartı Dialogu -->
    <v-dialog v-model="creditCardDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{ $t('Hotel-Credit-Card-Information') }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field :label="$t('Hotel-Card-Holder')" v-model="PaymentForm.CardHolderName" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('Card-Number')" v-model="PaymentForm.CardNumber" required></v-text-field>
              </v-col>
              <v-col cols="6" sm="4">
                <v-text-field :label="$t('Hotel-Card-Month')" v-model="PaymentForm.ExpirationMonth" required></v-text-field>
              </v-col>
              <v-col cols="6" sm="4">
                <v-text-field :label="$t('Hotel-Card-Year')" v-model="PaymentForm.ExpirationYear" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field :label="$t('Hotel-Card-CVC')" v-model="PaymentForm.CVC" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="creditCardDialog = false">{{ $t('cancel_button') }}</v-btn>
          <v-btn color="blue darken-1" text @click="submitCreditCardPayment">{{ $t('Hotel-Pay-By-Card') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <div v-if="this.kayitvarmi" class="page-header-card">
      <div>
        <div style="font-size:12px;opacity:0.75;margin-bottom:4px;">{{ $t('Transfer-Search') }} &rsaquo; {{
          $t('Reservation-Details-Breadcrumb') }}</div>
        <div style="font-size:22px;font-weight:600;">{{ $t('Transfer-Details-Title') }}</div>
      </div>
    </div>
    <v-form ref="formtransfer" v-model="validform" lazy-validation>
      <div style="background:#f0f2f5;min-height:100vh;">
        <v-layout row wrap style="max-width:90%;margin:0 auto;padding:16px;">

          <v-flex pa-1 xs12 sm12 md9>
            <v-layout row wrap>
              <v-flex pt-2 xs12 sm12 md12>
                <div class="section-card">
                  <div class="card-header purple-bar">
                    <div style="display:flex;align-items:center;gap:8px;">
                      <v-icon color="#667eea">people_alt</v-icon>
                      <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Passenger-Details') }}</span>
                    </div>
                  </div>


                  <div class="card-body">
                    <v-flex v-for="(item, index) in kisiBilgileri" :key="item.id" xs12 sm12 md12 class="mb-3">
                      <v-layout row wrap>
                        <adresaradialogcustom :value="dialogShowByIndex[index]" @input="dialogShowByIndex[index] = $event" :kisi="item"
                          @updatePassenger="updatePassenger($event, index)" />
                        <v-flex xs12 sm12 md12 mr-2>
                          <div style="display:flex;align-items:center;gap:12px;margin-bottom:12px;">
                            <div class="pax-number-badge">{{ index + 1 }}</div>
                            <div>
                              <div style="font-size:14px;font-weight:600;color:#1f2937;">
                                <span v-if="item.tip == 0">{{ $t('Passenger') }} {{ $t('Adult') }}</span>
                                <span v-if="item.tip == 1">{{ $t('Passenger') }} {{ $t('Child') }}</span>
                                <span v-if="item.tip == 2">{{ $t('Passenger') }} {{ $t('Baby') }}</span>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md4>
                          <v-text-field :disabled="item.CoperKisiID != null || passengersLocked" :label="$t('Name_label')"
                            :rules="[v => !!v || $t('Mandatory-section')]" v-model="item.Ad" outlined>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-text-field :label="$t('Surname_label')" :disabled="item.CoperKisiID != null || passengersLocked"
                            :rules="[v => !!v || $t('Mandatory-section')]" v-model="item.Soyad" outlined>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete :label="$t('Nationality')" :items="countryItems" item-text="name"
                            item-value="code" v-model="item.Ulke" :disabled="isUpdate || passengersLocked"
                            outline></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm12 md6 pr-1>
                          <v-text-field :label="$t('ID-Passport-No')" :rules="[v => !!v || $t('Mandatory-section')]"
                            v-model="item.TcKimlikNo" :disabled="passengersLocked" outlined></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <tarihim :etiket="$t('Birth-Date')" v-model="item.DogumTarihi"
                            :aktifmi="passengersLocked" :rules="[v => !!v || $t('Mandatory-section')]" />
                        </v-flex>

                        <v-flex v-if="item.id == 0" xs12 sm12 md6 pr-1>
                          <v-text-field :label="$t('Email_label')" :rules="[v => !!v || $t('Mandatory-section')]"
                            v-model="item.Email" :disabled="passengersLocked" outlined>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 v-if="item.id == 0" md6>
                          <phoneinput v-model="item.Phone" :rules="[v => !!v || $t('Mandatory-section')]"
                            @change="phoneDegisti($event, item)" :disabled="passengersLocked" :hideDetails="false" />
                        </v-flex>

                        <v-flex xs12 sm12 md6 pr-1>
                          <v-btn color="primary" @click="openDialog(index)" block outlined :disabled="passengersLocked">
                            <v-icon left small>search</v-icon>{{ $t('Passenger-Search') }}
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-btn color="primary" @click="adresKaydet(item)" block outlined :disabled="passengersLocked">
                            <v-icon left small>save</v-icon>{{ $t('Save-Passenger') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>
                </div>

              </v-flex>
              <v-flex xs12 sm12 md12 pt-2>
                <div class="section-card">
                  <div class="card-header green-bar">
                    <div style="display:flex;align-items:center;gap:8px;">
                      <v-icon color="#10b981">location_on</v-icon>
                      <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Pickup-Drop-off') }}</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6 pr-1>
                        <div style="font-size:14px;color:#6b7280;margin-bottom:4px;">{{ TransferResult.PickupPointName
                          }}</div>
                        <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" :label="$t('Flight-No')"
                          v-model="TransferData.FlightNumber" :disabled="passengersLocked" outlined dense>
                        </v-text-field>
                        <v-textarea :label="$t('Pickup-Point-Description')" v-model="TransferData.PickupPointInfo"
                          :disabled="passengersLocked" outlined dense></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <div style="font-size:14px;color:#6b7280;margin-bottom:4px;">{{ TransferResult.DropPointName }}
                        </div>
                        <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" :label="$t('Address_label')"
                          v-model="TransferData.Adress" :disabled="passengersLocked" outlined dense>
                        </v-text-field>
                        <v-textarea :label="$t('Explanation-Drop-off-Place')" v-model="TransferData.DropPointInfo"
                          :disabled="passengersLocked" outlined dense></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-textarea :label="$t('Reservation-Note')" v-model="TransferData.BookingInfo"
                          :disabled="passengersLocked" outlined dense></v-textarea>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </v-flex>
              <v-flex v-if="islemTipi != 'pdget'" pt-2 xs12 sm12 md12>
                <div class="section-card">
                  <div class="card-header amber-bar">
                    <div style="display:flex;align-items:center;gap:8px;">
                      <v-icon color="#f59e0b">account_balance</v-icon>
                      <span style="font-size:15px;font-weight:600;color:#1f2937;">{{ $t('Current-Details') }}</span>
                    </div>
                  </div>
                  <div class="card-body">
                    <caricomp v-bind:autofocuss="true" :Coper="true" v-bind:statecariyedek="stateCari"
                      v-bind:zorunlumu="true" v-bind:aktifmi="passengersLocked" v-model="cariKod">
                    </caricomp>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md3 style="margin-top: 8px;">
            <div class="sticky-sidebar">
              <!-- Transfer Photo & Title -->
              <v-card class="mb-3 elevation-2">
                <v-img :src="TransferResult.PhotoPath" height="200px"></v-img>
                <v-card-text style="padding:16px;">
                  <div style="font-size:16px;font-weight:700;color:#1f2937;margin-bottom:12px;">
                    {{ TransferResult.Title }}
                  </div>
                  <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:8px;">
                    <span style="color:#6b7280;">
                      <v-icon small color="#667eea" class="mr-1">supervisor_account</v-icon>{{ TransferResult.MaxPax }}
                      {{ $t('Passenger') }}
                    </span>
                  </div>
                  <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:8px;">
                    <span style="color:#6b7280;">
                      <v-icon small color="#667eea" class="mr-1">work</v-icon>{{ TransferResult.MaxSuitcase }}
                    </span>
                  </div>
                  <div style="display:flex;align-items:center;font-size:13px;color:#6b7280;margin:12px 0;">
                    <v-icon small color="#667eea" class="mr-1">calendar_month</v-icon>
                    {{ TransferResult.TransferInfo.DateAndTime }}
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div style="font-size:12px;color:#10b981;margin:8px 0;">
                    <v-icon small color="green">check</v-icon>{{ $t('Transfer-Free-Cancel-Until', { n: TransferResult.FreeCancelHourBefore }) }}
                  </div>
                  <div style="font-size:12px;color:#10b981;margin:8px 0;">
                    <v-icon small color="green">check</v-icon>{{ $t('Transfer-Free-Change-Until', { n: TransferResult.FreeChangeHourBefore }) }}
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div style="display:flex;justify-content:space-around;font-size:12px;padding:8px 0;">
                    <div style="text-align:center;">
                      <div style="color:#6b7280;">{{ $t('Adult') }}</div>
                      <div style="font-weight:600;color:#1f2937;font-size:14px;">{{
                        TransferResult.TransferInfo.AdultCount }}</div>
                    </div>
                    <div style="text-align:center;">
                      <div style="color:#6b7280;">{{ $t('Child') }}</div>
                      <div style="font-weight:600;color:#1f2937;font-size:14px;">{{
                        TransferResult.TransferInfo.ChildCount }}</div>
                    </div>
                    <div style="text-align:center;">
                      <div style="color:#6b7280;">{{ $t('Baby') }}</div>
                      <div style="font-weight:600;color:#1f2937;font-size:14px;">{{
                        TransferResult.TransferInfo.BabyCount }}</div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Price Summary -->
              <v-card class="mb-3 elevation-2">
                <div style="background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;padding:16px;">
                  <div style="font-size:13px;opacity:0.8;margin-bottom:4px;">{{ $t('Price-Details-v2') }}</div>
                  <div style="font-size:24px;font-weight:700;">{{ getparabirimi() }}</div>
                </div>

                <v-card-text style="padding:16px;">
                  <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:10px;">
                    <span style="color:#6b7280;">{{ $t('Cost') }}</span>
                    <parainput :isPositive="true" :simge="getparabirimi()"
                      v-model="TransferResult.PriceDetails.SystemPrice" :autocomplete="'autocomplete'" :reverse=true
                      :etiket="''"></parainput>
                  </div>
                  <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:10px;">
                    <span style="color:#6b7280;">{{ $t('Markup-Amount') }}</span>
                    <parainput :isPositive="true" :simge="getparabirimi()" v-model="TransferResult.PriceDetails.Markup"
                      :autocomplete="'autocomplete'" :reverse=true :etiket="''" aktif="false"></parainput>
                  </div>
                  <div
                    style="display:flex;justify-content:space-between;font-size:13px;padding-top:10px;border-top:1px solid #e5e7eb;margin-top:10px;">
                    <span style="color:#1f2937;font-weight:600;">{{ $t('totalamount') }}</span>
                    <parainput :isPositive="true" :simge="getparabirimi()"
                      v-model="TransferResult.PriceDetails.UserPrice" :autocomplete="'autocomplete'" :reverse=true
                      :aktif="'false'" :etiket="''"></parainput>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Action Buttons -->
              <v-card class="elevation-2">
                <v-card-text style="padding:14px;">
                  <template v-if="demoKayit">
                    <v-btn v-if="makeReservationFailed" color="warning" block large @click="retryMakeReservation()"
                      style="border-radius:10px;height:48px;font-weight:600;margin-bottom:8px;">
                      <v-icon left>refresh</v-icon>{{ $t('Try-Again') }}
                    </v-btn>
                    <v-btn v-else-if="paymentFailed" color="warning" block large @click="retryPayment()"
                      style="border-radius:10px;height:48px;font-weight:600;margin-bottom:8px;">
                      <v-icon left>refresh</v-icon>{{ $t('Retry-Payment') }}
                    </v-btn>
                    <v-btn v-else color="success" block large @click="TransferKaydetv3('cari')"
                      style="border-radius:10px;height:48px;font-weight:600;margin-bottom:8px;">
                      <v-icon left>account_balance</v-icon>{{ $t('Hotel-Pay-From-Current') }}
                    </v-btn>
                    <!--<v-btn block large @click="TransferKaydetv3('kart')"
                      style="background:#667eea;color:#fff;border-radius:10px;height:48px;font-weight:600;margin-bottom:8px;">
                      <v-icon left>credit_card</v-icon>Kredi Kartı ile Öde
                    </v-btn>-->

                  </template>

                  <v-btn v-else block large
                    style="background:#667eea;color:#fff;border-radius:10px;height:48px;font-weight:600;"
                    @click="irtibatDialog()">
                    <v-icon left>contact_mail</v-icon>{{ $t('CONTACT-US') }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </div>

          </v-flex>
        </v-layout>
      </div>
    </v-form>
  </div>
</template>

<script>
import auth from "@/api/auth.js";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import parainputevents from "@/components/app/customcomp/parainputevents";
import parainput from "@/components/app/customcomp/parainput";
import phoneinput from "@/components/app/customcomp/phoneinput";
import adresaradialogcustom from "@/components/app/customcomp/adresaradialogcustom";
import tool from "../../coper/tools";
import Airports from "../../satis/ucak/airports.js";
import { turOperatoruBulYaDaEkle } from "@/components/app/satis/otel/utils/rezervasyonkaydet.js";
export default {
  data() {
    return {
      dialogShowByIndex: {},
      prmPaxDriveAcenteKod: '',
      demoKayit: true,
      secilenKisiTip: null,
      secilenKisi: null,
      kisisecDialog: false,
      isimDefault: true,
      kisiListesi: [],
      kisiListesiItems: [],
      stateCari: [],
      kisiTipiItems: [],
      kisiBilgileri: [],
      cariKod: null,
      islemTipi: null,
      yetkidialog: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      loadingmesaj: "",
      loadingdialog: false,
      snackbar: false,
      text1: null,
      passengersLocked: false,
      makeReservationFailed: false,
      cariDialog: false,
      creditCardDialog: false,
      selectedPaymentType: null,
      paymentCompleted: false,
      finalizeShoppingCompleted: false,
      paymentFailed: false,
      billingInformationItem: Airports.billingInformation(),
      makePaymentItem: Airports.makePayment(),
      PaymentForm: {
        CardHolderName: "",
        CardNumber: "",
        ExpirationMonth: "",
        ExpirationYear: "",
        CVC: ""
      },
      ulkeitems: [],
      search: [],
      validform: true,
      odadetaydialog: false,
      odadetayi: {},
      kayitvarmi: false,
      onerilenkayitvarmi: false,
      yetiskinSayi: 1,
      Azalt: false,
      toplamFiyat: 0,
      menu: false,
      loadodaitems: null,
      adultItems: 0,
      childItems: 0,
      babyItems: 0,
      siralamatipiitems: [
        {
          text: this.$t("Price-Ascending"),
          value: "Price",
        },
        {
          text: this.$t("Price-Descending"),
          value: "PriceDesc",
        },
      ],
      kayitsayisi: [
        {
          text: "50",
          value: 50,
        },
        {
          text: "100",
          value: 100,
        },
      ],
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
      yetiskinitems: [],
      yetiskinkisibilgileri: [],
      cocukkisibilgileri: [],
      bebekkisibilgileri: [],
      countryItems: Airports.countiries(),
      TransferData: {
        FlightNumber: "",
        Adress: "",
        DropPointInfo: null,
        PickupPointInfo: null,
        BookingInfo: null,
      },
      TransferResult: {
        ProductId: null,
        Id: null,
        VehicleId: 0,
        ResponseId: 0,
        PickupPointId: 0,
        DropPointId: 0,
        PickupPoint: null,
        PickupPointName: null,
        DropPoint: null,
        Title: null,
        MaxPax: null,
        MaxSuitcase: null,
        BookingHour: null,
        FreeCancelHourBefore: null,
        FreeChangeHourBefore: null,
        PhotoPath: "",
        PriceDetails: {
          Markup: 0.0,
          SystemMarkup: 0.0,
          SystemPrice: 0.0,
          UserPrice: 0.0,
          DisplayPrice: 0.0,
        },
        PaxDetails: [],
        ExpireAt: null,
        TransferInfo: {
          AdultCount: 0,
          ChildCount: 0,
          BabyCount: 0,
          DateAndTime: null,
        },
      },
      turOperatoruSatici: null,
    };
  },
  mounted() {


    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      //YETKİ OK
      this.getProviders();
      if (
        this.$route.query.islemTipi != undefined &&
        this.$route.query.islemTipi != null
      ) {
        if (this.$route.query.islemTipi == "pdget") {
          this.islemTipi = "pdget";
        } else {
          this.islemTipi = "pdyeni";
        }
      } else {
        this.islemTipi = "pdyeni";
      }

      this.loadingdialog = true;
      this.loadingmesaj = this.$t('Your-transfer-details-are-being-accessed');

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var bookingParams = JSON.parse(
        window.localStorage.getItem("transferBookingParams")
      );
      var params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken
        },


        //ShoppingCartId:null,
        ResponseId: this.$route.query.responseId,
        ProductId: this.$route.query.vehicleId,
        Quantity: 1,
        AdultCount: this.$route.query.adultCount,
        ChildCount: this.$route.query.childCount,
        BabyCount: this.$route.query.babyCount,
        DateAndTime: this.$route.query.dateAndTime,
        // ProductId: this.$route.query.vehicleId,
        MarkupCurrency: this.$route.query.markupCurrency,
      };

      this.$http
        .post(auth.BOOKING_API_URL + "Transfer/Allocate", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.body.Status == false) {
              this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.progress = false;
            } else {



              var result = response.body.ShoppingCart.TransferBookings[0].Vehicle;

              this.ShoppingCartId = response.body.ShoppingCart.Id;
              this.PassengerBreakdowns = response.body.ShoppingCart.TransferBookings[0].PassengerBreakdowns || [];
              this.PaxReferanceId = this.PassengerBreakdowns[0] && this.PassengerBreakdowns[0].PaxReference && this.PassengerBreakdowns[0].PaxReference.PaxReferanceId;

              this.TransferResult.ProductId = result.ProductId;
              this.TransferResult.vehicleId = 0;
              this.TransferResult.Id = 0;
              this.TransferResult.ResponseId = 0;
              this.TransferResult.PickupPointId = result.PickupPointId;
              this.TransferResult.DropPointId = result.DropPointId;

              this.TransferResult.PickupPoint = this.$route.query.pickupText;
              this.TransferResult.DropPoint = this.$route.query.dropText;
              this.TransferResult.PickupPointName = this.$route.query.pickupText;
              this.TransferResult.DropPointName = this.$route.query.dropText;
              this.TransferResult.Title = result.Title;
              this.TransferResult.VehicleName = result.Name;
              this.TransferResult.Provider = result.Provider;
              this.TransferResult.MaxPax = result.MaxPax;
              this.TransferResult.MaxSuitcase = result.MaxSuitcase;
              this.TransferResult.BookingHour = result.BookingHour;
              this.TransferResult.FreeCancelHourBefore = result.FreeCancelHourBefore;
              this.TransferResult.FreeChangeHourBefore = result.FreeChangeHourBefore;
              this.TransferResult.PhotoPath = "https://partner.paxdrive.com" + result.PhotoPath;
              this.TransferResult.PriceDetails = result.PriceDetails;
              this.TransferResult.PaxDetails = result.PaxDetails;




              this.TransferResult.TransferInfo.AdultCount = this.$route.query.adultCount;

              this.TransferResult.TransferInfo.ChildCount = this.$route.query.childCount;
              this.TransferResult.TransferInfo.BabyCount = this.$route.query.babyCount;
              this.TransferResult.TransferInfo.DateAndTime = this.$route.query.dateAndTime;



              this.kisiListesiItems = [];

              var pdtransfer = JSON.parse(
                window.localStorage.getItem("pdtransfer")
              );

              if (pdtransfer != null && this.islemTipi == "pdget") {
                pdtransfer.Rezervasyon.adresler.forEach((element) => {
                  var index = pdtransfer.Rezervasyon.adresler.indexOf(element);

                  var kayit = {
                    id: index,
                    adSoyad: element.adSoyad,
                    tip: element.kisiTip,
                  };

                  this.kisiListesiItems.push(kayit);
                });
              } else {
              }
            }

            this.loadingdialog = false;

          },
          (response) => {
            this.text1 = this.$t('Transfer-Search-Error');
            this.snackbar = true;
            this.progress = false;
            this.loadingdialog = false;
          }
        );

      var i, k, j;
      this.kisiTipiItems = [];

      var top =
        parseInt(this.$route.query.adultCount) +
        parseInt(this.$route.query.childCount) +
        parseInt(this.$route.query.babyCount);

      // yetişkin tip 0, çocuk 1 ,baby 2

      for (i = 0; i < this.$route.query.adultCount; i++) {
        var kayit = {

          id: i,
          tip: 0,
        };

        this.kisiTipiItems.push(kayit);
      }

      for (
        k = i;
        k <
        parseInt(this.$route.query.adultCount) +
        parseInt(this.$route.query.childCount);
        k++
      ) {
        var kayit = {
          id: k,
          tip: 1,
        };
        this.kisiTipiItems.push(kayit);
      }

      for (j = k; j < top; j++) {
        var kayit = {
          id: j,
          tip: 2,
        };
        this.kisiTipiItems.push(kayit);
      }

      this.kisiBilgileri = [];

      i = 0;

      this.kisiTipiItems.forEach((element) => {
        var yeni = {
          sira: null,
          id: parseInt(i),
          tip: element.tip,
          Ad: null,
          Soyad: null,
          TcKimlikNo: null,
          Ulke: null,
          CoperKisiID: null,
          DogumTarihi: null,
        };
        this.kisiBilgileri.push(yeni);
        i++;
      });
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
        setTimeout(() => {
        this.countryItems.sort((a, b) => {
          if (!a.name || !b.name) return 0;
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
      }, 1500);
    }

  },
  beforeMount: beforeMount,
  methods: {
    openDialog(index) {
      this.$set(this.dialogShowByIndex, index, true);
    },
    updatePassenger(pax, index) {
      console.log("Updating passenger at index:", index, "with data:", pax);
      this.$set(this.kisiBilgileri, index, {
        ...this.kisiBilgileri[index],
        Ad: pax.FirstName,
        Soyad: pax.LastName,
        TcKimlikNo: pax.CitizenNo || pax.PassportNo,
        Ulke: pax.Nationality,
        CoperKisiID: pax.CoperKisiID,
        DogumTarihi: pax.BirthDate || this.kisiBilgileri[index].DogumTarihi,
        Email: pax.Email,
        Phone: pax.Phone || this.kisiBilgileri[index].Phone,
      })
      this.$set(this.dialogShowByIndex, index, false);
    },
    adresKaydet(pax) {
      var endpoint = pax.CoperKisiID ? 'AdresUpdate' : 'AdresInsert';
      var credentials = JSON.parse(
        window.localStorage.getItem("credentials")
      );
      var params = {
        Value: {
          Id: pax.CoperKisiID,
          Ad: pax.Ad,
          Soyad: pax.Soyad,
          SirketNo: credentials.CoperSirketNo,
          PasaportNo: pax.TcKimlikNo,
          GSM: pax.Phone,
          TCKimlikNo: pax.CitizenNo,
          Email: pax.Email,
          DogumTarihi: pax.DogumTarihi,
          Ulke: pax.Ulke,
        },
      };
      tool.http_post(this, endpoint, params).then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 = this.$t('Record-Added');
            this.snackbar = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );

    },
    getProviders() {
      let itemsproviders = [];
      var bookingParams = JSON.parse(
        window.localStorage.getItem("transferBookingParams")
      );
      var params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken
        }
      };

      this.$http
        .post(auth.BOOKING_API_URL + "Agency/GetCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            console.log(response.body);
            var rsp = response.body.Credentials;
            rsp.forEach(element => {
              if (element.ProviderType == 'Transfer' && element.Provider == "Paxdrive") {
                this.prmPaxDriveAcenteKod = element.OfficeId;
              }

            });

            this.loadingdialog = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = this.$t('Service-Unavailable');
              this.loadingdialog = false;
              this.snackbar = true;
            } else {
              this.text1 = this.$t('Service-Unavailable');
              this.loadingdialog = false;
              this.snackbar = true;
            }
          }
        );
    },
    toIsoDateTime(val) {
      if (!val) return null;


      return val.replace(" ", "T") + ":00";
    },
    phoneDegisti(yeniNumara, item) {
      // yeniNumara parametresi phoneinput'tan dönen +90... formatındaki değerdir.
      // v-model zaten item.Phone'u güncelliyor ancak ana TransferData'ya da aktarmak isteyebilirsin:
      if (item.id === 0) {
        this.TransferData.Phone = yeniNumara;
      }
      console.log(this.TransferData);
    },
    async TransferKaydetv3(paymentType) {
      this.selectedPaymentType = paymentType;
      this.loadingdialog = true;
    
      try {
        await this.submitBilling();
        await this.UpdatePassengers();
      } catch (error) {
        this.loadingdialog = false;
        this.text1 = error.message || this.$t('An-error-has-occurred-Please-try-again');
        this.snackbar = true;
        return;
      }
      this.passengersLocked = true;
      await this.attemptMakeReservation();
    },
    async attemptMakeReservation() {
      this.loadingdialog = true;
      try {
        await this.MakeReservation();
        this.loadingdialog = false;
        this.makeReservationFailed = false;
        if (this.selectedPaymentType === 'kart') {
          this.creditCardDialog = true;
        } else {
          this.cariDialog = true;
        }
      } catch (error) {
        this.loadingdialog = false;
        this.makeReservationFailed = true;
        this.text1 = error.message || this.$t('An-error-has-occurred-Please-try-again');
        this.snackbar = true;
      }
    },
    retryMakeReservation() {
      this.attemptMakeReservation();
    },
    async MakeReservation() {
      const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));

      const params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken,
        },
        ShoppingCartId: this.ShoppingCartId,
        BaggageAllowance: "",
        LinkUrl: "",
        SelectedServiceFee: 0,
        ContinueWithoutReservation: true,
      };

      try {
        const response = await this.$http.post(
          auth.BOOKING_API_URL + "Transfer/MakePreBooking",
          params,
          {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
            },
          }
        );
        if (response.body.HasError) {
          console.error("Rezervasyon başarısız:", response.body);
          const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Reservation-Failed-Retry');
          throw new Error(errorMsg);
        }
        console.log("Rezervasyon yapıldı:", response.body);
      } catch (error) {
        console.error("Rezervasyon başarısız:", error);
        throw error;
      }
    },
    async FinalizeShopping() {
      const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));

      const params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken,
        },
        ShoppingCartId: this.ShoppingCartId,
      };

      try {
        const response = await this.$http.post(
          auth.BOOKING_API_URL + "Transfer/FinalizeShopping",
          params,
          {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
            },
          }
        );
        if (response.body.HasError) {
          console.error("Booking başarısız:", response.body);
          const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Reservation-Failed-Retry');
          throw new Error(errorMsg);
        }
        this.karsiRezKod = response.body.ShoppingCart.TransferBookings[0].Pnr;
        console.log("Booking tamamlandı:", response.body);
      } catch (error) {
        console.error("Booking başarısız:", error);
        throw error;
      }
    },
    async submitBilling() {
      const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));

      this.billingInformationItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.billingInformationItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.billingInformationItem.ShoppingCartId = this.ShoppingCartId;

      try {
        const response = await this.$http.post(
          auth.BOOKING_API_URL + "Billing/Submit",
          this.billingInformationItem,
          {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
            },
          }
        );
        if (response.body.HasError) {
          console.error("Billing başarısız:", response.body);
          const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Billing-Failed-Retry');
          throw new Error(errorMsg);
        }
        console.log("Billing tamamlandı:", response.body);
      } catch (error) {
        console.error("Billing başarısız:", error);
        throw error;
      }
    },
    async MakePayment() {
      const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));

      this.makePaymentItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePaymentItem.SessionHeader.SessionToken = bookingParams.SessionToken;
      this.makePaymentItem.ShoppingCartId = this.ShoppingCartId;
      this.makePaymentItem.Amount = this.TransferResult.PriceDetails.UserPrice;

      if (this.selectedPaymentType === 'kart') {
        this.makePaymentItem.PaymentType = "CreditCardPayment";
        this.PaymentForm.ExpirationYear = this.PaymentForm.ExpirationYear.slice(-2);
        this.makePaymentItem.PaymentForm = this.PaymentForm;
        this.makePaymentItem.PaymentForm.InstallmentId = this.ShoppingCartId;
      } else {
        this.makePaymentItem.PaymentType = "CurrentPayment";
      }

      try {
        const response = await this.$http.post(
          auth.BOOKING_API_URL + "MakePayment",
          this.makePaymentItem,
          {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
            },
          }
        );
        if (response.body.HasError) {
          console.error("Ödeme başarısız:", response.body);
          const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('Payment-Failed-Retry');
          throw new Error(errorMsg);
        }
        console.log("Ödeme tamamlandı:", response.body);
      } catch (error) {
        console.error("Ödeme başarısız:", error);
        throw error;
      }
    },
    confirmCariPayment() {
      this.cariDialog = false;
      this.completePaymentAndFinalize();
    },
    submitCreditCardPayment() {
      this.creditCardDialog = false;
      this.completePaymentAndFinalize();
    },
    async completePaymentAndFinalize() {
      this.loadingdialog = true;
      try {
        if (!this.paymentCompleted) {
          await this.MakePayment();
          this.paymentCompleted = true;
        }
        if (!this.finalizeShoppingCompleted) {
          await this.FinalizeShopping();
          this.finalizeShoppingCompleted = true;
        }
        await this.sendNext();
        this.loadingdialog = false;
        this.paymentFailed = false;
      } catch (error) {
        this.loadingdialog = false;
        this.paymentFailed = true;
        this.text1 = error.message || this.$t('An-error-has-occurred-Please-try-again');
        this.snackbar = true;
      }
    },
    retryPayment() {
      this.completePaymentAndFinalize();
    },
    async UpdatePassengers() {
      let yolcular = [];
      const bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));
      const firstPassengerEmail = this.kisiBilgileri[0] && this.kisiBilgileri[0].Email;
      const firstPassengerPhone = this.kisiBilgileri[0] && this.kisiBilgileri[0].Phone;

      var breakdownsByType = { ADT: [], CHD: [], INF: [] };
      (this.PassengerBreakdowns || []).forEach((b) => {
        var code = b.PaxReference && b.PaxReference.PaxCode;
        if (breakdownsByType[code]) {
          breakdownsByType[code].push(b.PaxReference.PaxReferanceId);
        }
      });

      // Doğum tarihi validasyonu
      for (let i = 0; i < this.kisiBilgileri.length; i++) {
        const element = this.kisiBilgileri[i];
        if (!element.DogumTarihi) {
          throw new Error(this.$t('Passenger-Birthdate-Required', { name: element.Ad || (this.$t('Passenger') + ' ' + (i + 1)) }));
        }

        const birthDate = new Date(element.DogumTarihi);
        const today = new Date();
        const totalDays = Math.floor((today - birthDate) / (1000 * 60 * 60 * 24));

        let isCorrect = false;
        let expectedType = '';

        switch (element.tip) {
          case 2: // INF
            isCorrect = totalDays < 730;
            expectedType = this.$t('Transfer-Type-Baby');
            break;
          case 0: // ADT
            isCorrect = totalDays > 3987;
            expectedType = this.$t('Transfer-Type-Adult');
            break;
          case 1: // CHD
            isCorrect = totalDays < 4376 && totalDays > 730;
            expectedType = this.$t('Transfer-Type-Child');
            break;
        }

        if (!isCorrect) {
          throw new Error(this.$t('Passenger-Birthdate-Category-Mismatch', { name: element.Ad || (this.$t('Passenger') + ' ' + (i + 1)), type: expectedType }));
        }
      }

      this.kisiBilgileri.forEach((element) => {
        var paxtype = "ADT";
        var ischild = false;
        if (element.tip == 1) {
          paxtype = "CHD";
          ischild = true;
        }
        if (element.tip == 2) {
          paxtype = "INF";
          ischild = true;
        }

        var paxReferanceId = (breakdownsByType[paxtype] && breakdownsByType[paxtype].shift()) || this.PaxReferanceId;
        var isTurkish = element.Ulke === 'TR';
        var yeniyolcu = {
          FirstName: element.Ad,
          LastName: element.Soyad,
          PaxType: paxtype,
          Gender: 'Male',
          BirthDate: element.DogumTarihi || '1980-01-01',
          Email: element.Email || firstPassengerEmail,
          Phone: element.Phone || firstPassengerPhone,
          CitizenNo: isTurkish ? element.TcKimlikNo : '00000000000',
          PassportNo: isTurkish ? '' : element.TcKimlikNo,
          PassportExpireDate: '',
          Nationality: element.Ulke,
          HesCode: '',
          FrequentFlayerNo: '',
          WheelChairService: 0,
          PaxReferanceId: paxReferanceId,
          ExtraPosAmount: 0.0,
          isChild: ischild,
          Address: '',
          AddressCountry: '',
          AddressCity: '',
          SelectedShuttle: null,
        };
        yolcular.push(yeniyolcu);

      });


      const params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken,
        },
        ShoppingCartId: this.ShoppingCartId,
        CorporatePin: '',
        Contact: {
          Name: yolcular[0].FirstName,
          LastName: yolcular[0].LastName,
          Phone: yolcular[0].Phone,
          Email: yolcular[0].Email,
        },
        Passengers: yolcular,
        ReturnPassengers: null,
        EArchiveWebAddress: 88,
        Notes: this.TransferData.BookingInfo,
        PickupPointExplanation: this.TransferData.PickupPointInfo,
        DropPointExplanation: this.TransferData.DropPointInfo,
      };

      try {
        const response = await this.$http.post(
          auth.BOOKING_API_URL + "Transfer/UpdatePassengers",
          params,
          {
            headers: {
              Authorization:
                "Basic " +
                window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
            },
          }
        );

        if (response.body.HasError) {
          console.error("Yolcu güncelleme hatası:", response.body);
          const errorMsg = (response.body.ServiceError && response.body.ServiceError.ErrorMessages && response.body.ServiceError.ErrorMessages[0]) || this.$t('An-error-has-occurred-Please-try-again');
          throw new Error(errorMsg);
        }
        console.log("Yolcular başarıyla güncellendi");

      } catch (error) {
        console.error("Yolcu güncelleme hatası:", error);
        throw error;
      }
    },
    durdurGonderim() {
      this.stopRequested = true;
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },



    async checkOrUpdateSatici() {
      const prm = { saticiKodu: this.prmPaxDriveAcenteKod, saticiTipi: "2" };
      const response = await tool.http_post(this, "SaticiKodBul", prm);
      if (response.body.Status !== true) {
        throw new Error(response.body.ErrorList ? response.body.ErrorList[0] : this.$t('Reservation-Failed-Retry'));
      }

      const maxPax = parseInt(this.TransferResult.MaxPax) || 0;
      const yeniArac = {
        AnaTip: "KARA",
        AltTip: this.TransferResult.VehicleName || this.TransferResult.Title,
        AracAdi: this.TransferResult.Title,
        YazEnAz: 0,
        YazEnCok: maxPax,
        KisEnAz: 0,
        KisEnCok: maxPax,
      };

      if (response.body.Satici == null) {
        const yeniSatici = {
          SaticiTipi: 2,
          Kod: this.prmPaxDriveAcenteKod,
          Isim: this.prmPaxDriveAcenteKod,
          stArac: { AracTipi: [yeniArac], Donem1: null, Donem2: null },
        };
        const insertResp = await tool.http_post(this, "SaticiKayit", yeniSatici);
        if (insertResp.body.Status !== true) {
          throw new Error(insertResp.body.ErrorList ? insertResp.body.ErrorList[0] : this.$t('Reservation-Failed-Retry'));
        }
      } else {
        const satici = response.body.Satici;
        if (!satici.stArac) satici.stArac = { AracTipi: [], Donem1: null, Donem2: null };
        if (!satici.stArac.AracTipi) satici.stArac.AracTipi = [];
        const exists = satici.stArac.AracTipi.some(a => a.AracAdi === yeniArac.AracAdi);
        if (!exists) {
          satici.stArac.AracTipi.push(yeniArac);
          const updateResp = await tool.http_post(this, "SaticiUpdate", satici);
          if (updateResp.body.Status !== true) {
            throw new Error(updateResp.body.ErrorList ? updateResp.body.ErrorList[0] : this.$t('Reservation-Failed-Retry'));
          }
        }
      }

      const extractProviderName = (provider) => {
        if (!provider) return null;
        if (typeof provider === 'string') return provider;
        return provider.Name || provider.ProviderName || provider.Code || null;
      };

      const providerAdi = extractProviderName(this.TransferResult.Provider);
      if (providerAdi) {
        this.turOperatoruSatici = await turOperatoruBulYaDaEkle(this, providerAdi);
      } else {
        console.warn('TurOperatoru: Provider adı bulunamadı, turOperatoru boş bırakılacak.', this.TransferResult.Provider);
        this.turOperatoruSatici = null;
      }
    },

    async sendNext() {
      await this.checkOrUpdateSatici();
      var sira = 0;
      var yolcular = [];
      this.kisiBilgileri.forEach((element) => {

        var yeniyolcu = {
          id: -1,
          kisiTip: element.tip,
          kisiSira: sira,
          yas: 0,
          profilId: 0,
          sicilId: 0,
          tcKimlikNo: element.TcKimlikNo,
          uyeNo: "",
          lastName: element.Soyad,
          firstName: element.Ad,
          adSoyad: element.Ad + ' ' + element.Soyad,
          adres: "",
          dogumTarihi: element.DogumTarihi || null,
          cinsiyet: "",
          telefon1: "",
          gsm: element.Phone,
          eMail: element.Email

        };
        yolcular.push(yeniyolcu);
        sira += 1;
      });

      var Rezervasyonprm = {
        pNR_No: 0,
        MisafirIsmiKontrolEdilmesin: false,
        Status: 0,
        FaturaBilgileri: [],
        kayitTarihi: tool.Now_yyyy_MM_dd(),
        cariKod: {
          id: "",
          kod: this.cariKod,
          isim: "",
          isimAra: ""
        },
        rezVeren: "",
        masrafMerkezi: {
          id: "",
          kod: "",
          isim: "",
          isimAra: ""
        },
        anaTip: 0,
        ulke: null,
        karsiRezKod: this.karsiRezKod || "",
        turKod: "",
        acenteDepartman: {
          id: "",
          kod: "",
          isim: "",
          isimAra: ""
        },
        hizmetNo: "",
        referansKod: "",
        adresler: yolcular,
        kalemler: [
          {
            islemRef: 0,
            saticiEntegrasyon: null,
            entTip: null,
            entId: null,
            donem1: this.toIsoDateTime(this.$route.query.dateAndTime),
            donem2: this.toIsoDateTime(this.$route.query.dateAndTime),
            satis: {
              KDVOran: 10
            },
            alis: {
              KDVOran: 0
            },
            komisyon: {
              KDVOran: null,
              tutar: 0
            },
            acenteKomisyon: null,
            iskonto: {
              oran: 0,
              tutar: 0,
              iskontoSebebi: null
            },
            odeyenTaraf: 1,
            aciklama: null,
            tedarikciAciklama: null,
            turOperatoru: this.turOperatoruSatici ? {
              id: this.turOperatoruSatici.id,
              kod: this.turOperatoruSatici.kod,
              isim: this.turOperatoruSatici.isim,
              isimAra: this.turOperatoruSatici.isim
            } : {
              id: null,
              kod: null,
              isim: null,
              isimAra: null
            },
            departman: {
              id: null,
              kod: null,
              isim: null,
              isimAra: null
            },
            kdvID: {
              id: null,
              kod: null,
              isim: null,
              isimAra: null
            },
            kdvMuafiyetID: {
              id: null,
              kod: null,
              isim: null,
              isimAra: null
            },
            entegrasyonKodu: null,
            maliyetCariKod: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            saticiTip: 2,
            kisiSira: [0],
            yet_Satis: this.TransferResult.PriceDetails.SystemPrice,
            co1_Satis: 0,
            co2_Satis: 0,
            co3_Satis: 0,
            co4_Satis: 0,
            ekY_Satis: 0,
            yet_Alis: 0,
            co1_Alis: 0,
            co2_Alis: 0,
            co3_Alis: 0,
            co4_Alis: 0,
            ekY_Alis: 0,
            yet_KisiSayisi: 1,
            co1_KisiSayisi: 0,
            co2_KisiSayisi: 0,
            co3_KisiSayisi: 0,
            co4_KisiSayisi: 0,
            ekY_KisiSayisi: 0,
            satici: {
              id: "",
              isim: "",
              KDV: 10,
              kod: this.prmPaxDriveAcenteKod,
              CariKod: "",
              YurtIci_YurtDisi: 0,
              isimAra: ""
            },
            alisPara: {
              paraBirimi: "TL",
              kur: 1,
              kurTarihi: null
            },
            satisPara: {
              paraBirimi: "TL",
              kur: 1,
              kurTarihi: null
            },
            komisyonPara: {
              paraBirimi: "TL",
              kur: 1,
              kurTarihi: null
            },
            komisyonYuzdeTip: 0,
            komisyonYuzde: 0,
            komisyonTutar: 0,
            P_RP: "P",
            KKartNo: null,
            KKartOdemeTipi: 0,
            masrafMerkezi: {
              id: "",
              kod: "",
              isim: "",
              isimAra: ""
            },
            kalemOtel: null,
            kalemArac: {
              tip: null,
              ucusNo: this.TransferData.FlightNumber,
              ucusSaat: null,
              tasimaTipi: null,
              bolge: null,
              nerden: this.TransferResult.PickupPointName,
              nereye: this.TransferResult.DropPointName,
              arac: this.TransferResult.Title,
              aracAdet: 1,
              rehberDili: null,
              rehberAdet: null,
              seferNo: null,
              seferId: null,
              seferSaat: null,
              ADT: null,
              tasimaTipRef: null,
              rehber: {
                id: null,
                kod: null,
                isim: null,
                tip: null,
                YurtIci_YurtDisi: null
              },
              pinCode: null,
              otelKod: null,
              SoforTahsilat: null,
              seferVarisId: null,
              odaNo: null,
              transferDurumu: null
            },
            kalemRestaurant: null,
            kalemMuze: null,
            kalemDiger: null,
            kalemRentACar: null,
            kalemVize: null,
            kalemSigorta: null,
            kalemGemi: null,
            kalemRehber: null,
            kalemAcente: null,
            kalemCharter: null,
            kalemFeribot: null,
            kalemGolf: null
          }
        ],
        odemeler: [],
        toplamTL: {
          satis: 0,
          alis: 0,
          komisyon: 0,
          iskonto: 0
        },
        opsiyonluMusteri: false,
        opsiyonTarihi: null,
        opsiyonSaati: null,
        acente: {
          id: null,
          kod: this.prmPaxDriveAcenteKod,
          isim: null,
          isimAra: this.prmPaxDriveAcenteKod,
          YurtIci_YurtDisi: 0,
          KDV: 10,

        }
      };
      try {
        const response = await tool.http_post(this, "RezervasyonKaydet", { Rezervasyon: Rezervasyonprm });
        console.log("RezervasyonKaydet Response:", response.body);

        if (response.body.Status !== true) {
          console.error("RezervasyonKaydet Hata:", response.body.ErrorList);
          throw new Error(response.body.ErrorList ? response.body.ErrorList[0] : this.$t('Reservation-Failed-Retry'));
        }

        this.text1 = this.$t('Reservation-Process-Completed');
        this.snackbar = true;
        this.loadingdialog = false;

        var pnrNo = response.body.data ? response.body.data.pNR_No : response.body.pNR_No;
        console.log("PNR No:", pnrNo);
        if (pnrNo) {
          var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + pnrNo;
          window.open(url, "_target");
        } else {
          console.warn("PNR numarası bulunamadı, paxdrive/index sayfasına yönlendiriliyor");
          setTimeout(
            function () {
              var url = "/#/coper/paxdrive/index/id";
              location.href = url;
              location.reload();
            }.bind(this),
            3000
          );
        }
      } catch (error) {
        console.error("RezervasyonKaydet API Hatası:", error);
        throw error;
      }
    },






    getparabirimi() {
      return ""; // helpers.getparabirimi()
    },
    irtibatDialog() {
      this.$refs.tanitimdialog.open(0);
    },
    getAccountDetails() {
      this.loadingvmodel = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CustomerID: credentials.MusteriID,
        ServiceID: 3,
      };

      this.$http
        .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            auth.HOTELRUNNERUSERNAME = response.body.UserName;
            auth.HOTELRUNNERUSERPASS = response.body.Password;
            this.demoKayit = response.body.Active;

          },
          (response) => {
            if (response.status === 0) {
              this.text1 = this.$t('Service-Unavailable');
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = this.$t('Service-Unavailable');
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    getEklimi(val) {
      var kayitEklimi = this.kisiBilgileri
        .map(function (e) {
          return e.sira;
        })
        .indexOf(val.id);

      if (kayitEklimi == -1) {
        return true;
      } else {
        return false;
      }
    },

    kisiAktar(val) {
      var kayitEklimi = this.kisiBilgileri
        .map(function (e) {
          return e.sira;
        })
        .indexOf(val.id);
      if (kayitEklimi == -1) {
        var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));
        var tip = 0;
        if (val.tip == 1) {
          tip = 1;
        } else if (val.tip == 2) {
          tip = 2;
        } else {
          tip = 0;
        }

        var yeni = {
          id: this.secilenKisi,
          sira: val.id,
          tip: tip,
          Ad: pdrive.Rezervasyon.adresler[val.id].firstName,
          Soyad: pdrive.Rezervasyon.adresler[val.id].lastName,
          TcKimlikNo: pdrive.Rezervasyon.adresler[val.id].tcKimlikNo,
          Ulke: null,
          CoperKisiID: pdrive.Rezervasyon.adresler[val.id].id,
          DogumTarihi: null,
        };

        if (this.secilenKisi == 0) {
          this.TransferData.Email = pdrive.Rezervasyon.adresler[val.id].eMail;
          this.TransferData.Phone = pdrive.Rezervasyon.adresler[val.id].gsm;
        }

        this.kisiBilgileri.splice(this.secilenKisi, 1, yeni);
        this.kisisecDialog = false;
      } else {
        this.text1 = this.$t('Person-added-you-cannot-add-them-again')
        this.snackbar = true;
      }
    },
    kisiKaldir(val) {
      var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));

      var kisiid = pdrive.Rezervasyon.adresler[val.id].id;
      var kayitEklimi = this.kisiBilgileri
        .map(function (e) {
          return e.CoperKisiID;
        })
        .indexOf(kisiid);
      var yeni = {
        id: this.kisiBilgileri[kayitEklimi].id,
        sira: null,
        tip: this.kisiBilgileri[kayitEklimi].tip,
        Ad: null,
        Soyad: null,
        TcKimlikNo: null,
        Ulke: null,
        CoperKisiID: null,
        DogumTarihi: null,
      };

      this.kisiBilgileri.splice(kayitEklimi, 1, yeni);
      this.kisisecDialog = false;
    },
    getkisiDurum(a) {
      var tip;
      if (a != 1 && a != 2) {
        tip = 0;
      } else {
        tip = a;
      }

      if (this.secilenKisiTip == a) {
        return true;
      } else {
        return false;
      }
    },
    kisisec(a) {
      this.secilenKisi = this.kisiBilgileri.indexOf(a);
      this.kisisecDialog = true;
      this.secilenKisiTip = a.tip;
    },
    getSaticiBilgileri(val) {
      var Satici = {
        Aciklamalar: "Pax Drive",
        Adres: null,
        Email: null,
        Fax: null,
        GSM: null,
        HavaAlani: null,
        IcDis: 0,
        Isim: "Pax Drive",
        Kod: "PAX",
        PK: null,
        SaticiKonumu: null,
        Sehir: null,
        Tel1: null,
        Tel2: null,
        Teleks: null,
        Tip: 2,
        Ulke: "TR",
        VDaire: null,
        VNo: null,
        Web: null,
        Yer: null,
        Yetkili: null,
      };

      return Satici;
    },
    getPersonInfo(tip) {
      var kisiler = [];

      this.kisiBilgileri.forEach((element) => {
        if (tip == element.tip) {
          var kayit = {
            Name: element.Ad,
            LastName: element.Soyad,
            IdNo: element.TcKimlikNo,
            Nationality: element.Ulke,
          };
          kisiler.push(kayit);
        }
      });

      return kisiler;
    },
    getodaDetay(id, val) {
      if (id == 0) {
        var detay = {
          OdaAd: this.Odaitems.OdaAd,
          OdaGorsel: this.Odaitems.OdaGorsel,
          SinifAd: this.Odaitems.SinifAd,
          OdaOzellik: this.Odaitems.OdaOzellik,
        };
        this.odadetayi = detay;
      } else if (id == 1) {
        var detay = {
          OdaAd: val.OdaAd,
          OdaGorsel: val.OdaGorsel,
          SinifAd: val.SinifAd,
          OdaOzellik: val.OdaOzellik,
        };
        this.odadetayi = detay;
      }

      this.odadetaydialog = true;
    },
    getodaGorsel() {
      if (this.Odaitems.OdaGorsel.length > 0) {
        return this.Odaitems.OdaGorsel[0].Url;
      }
    },
    yetiskinArttir() {
      this.Azalt = false;
      this.yetiskinSayi++;
    },
    yetiskinAzalt() {
      if (this.yetiskinSayi >= 2) {
        this.yetiskinSayi--;
      } else {
        this.Azalt = true;
      }
    },
    TransferKaydet: TransferKaydet,
    UlkeCek: UlkeCek,

  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    coperdateformat: function (t) {
      return helpers.coperdateformat(t);
    },

    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    gettime: function (t) {
      return helpers.getTime(t);
    },
    ilkfoto: function (a) {
      return a[0].Url;
    },
  },
  watch: {
    'TransferResult.PriceDetails.Markup': function (tutar) {
      this.TransferResult.PriceDetails.UserPrice = this.TransferResult.PriceDetails.Markup + this.TransferResult.PriceDetails.SystemPrice;
    },
    'TransferResult.PriceDetails.SystemPrice': function (tutar) {
      this.TransferResult.PriceDetails.UserPrice = this.TransferResult.PriceDetails.Markup + this.TransferResult.PriceDetails.SystemPrice;
    },
    kisiListesi: function (val) {
      this.kisiTipiItems = [];
      var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));

      this.kisiBilgileri = [];

      var i = 0;

      val.forEach((element) => {
        // yetişkin tip 0, çocuk 1 ,baby 2

        var tip = 0;

        if (pdrive.Rezervasyon.adresler[element].kisiTip == 1) {
          tip = 1;
        } else if (pdrive.Rezervasyon.adresler[element].kisiTip == 2) {
          tip = 2;
        } else {
          tip = 0;
        }

        var yeni = {
          id: parseInt(i),
          sira: element,
          tip: tip,
          Ad: pdrive.Rezervasyon.adresler[element].firstName,
          Soyad: pdrive.Rezervasyon.adresler[element].lastName,
          TcKimlikNo: pdrive.Rezervasyon.adresler[element].tcKimlikNo,
          Ulke: null,
          CoperKisiID: pdrive.Rezervasyon.adresler[element].id,
          DogumTarihi: null,
        };
        this.kisiBilgileri.push(yeni);

        i = i + 1;
      });
    },
    isimDefault: function (val) {

      if (val == true) {
        var i, k, j;

        this.kisiTipiItems = [];

        var top =
          parseInt(this.$route.query.adultCount) +
          parseInt(this.$route.query.childCount) +
          parseInt(this.$route.query.babyCount);

        // yetişkin tip 0, çocuk 1 ,baby 2

        for (i = 0; i < this.$route.query.adultCount; i++) {
          var kayit = {
            id: i,
            tip: 0,
          };
          this.kisiTipiItems.push(kayit);
        }

        for (
          k = i;
          k <
          parseInt(this.$route.query.adultCount) +
          parseInt(this.$route.query.childCount);
          k++
        ) {
          var kayit = {
            id: k,
            tip: 1,
          };
          this.kisiTipiItems.push(kayit);
        }

        for (j = k; j < top; j++) {
          var kayit = {
            id: j,
            tip: 2,
          };
          this.kisiTipiItems.push(kayit);
        }

        this.kisiBilgileri = [];

        i = 0;

        this.kisiTipiItems.forEach((element) => {
          var yeni = {
            id: parseInt(i),
            sira: null,
            tip: element.tip,
            Ad: null,
            Soyad: null,
            TcKimlikNo: null,
            Ulke: null,
            CoperKisiID: null,
            DogumTarihi: null,
          };
          this.kisiBilgileri.push(yeni);
          i++;
        });
      } else {
        this.kisiBilgileri = [];

        if (this.kisiListesi.length != 0) {
          this.kisiTipiItems = [];

          var pdrive = JSON.parse(window.localStorage.getItem("pdtransfer"));

          this.kisiBilgileri = [];

          var i = 0;

          this.kisiListesi.forEach((element) => {
            // yetişkin tip 0, çocuk 1 ,baby 2

            var tip = 0;

            if (pdrive.Rezervasyon.adresler[element].kisiTip == 1) {
              tip = 1;
            } else if (pdrive.Rezervasyon.adresler[element].kisiTip == 2) {
              tip = 2;
            } else {
              tip = 0;
            }

            var yeni = {
              id: parseInt(i),
              sira: element,
              tip: tip,
              Ad: pdrive.Rezervasyon.adresler[element].firstName,
              Soyad: pdrive.Rezervasyon.adresler[element].lastName,
              TcKimlikNo: pdrive.Rezervasyon.adresler[element].tcKimlikNo,
              Ulke: null,
              CoperKisiID: pdrive.Rezervasyon.adresler[element].id,
              DogumTarihi: null,
            };
            this.kisiBilgileri.push(yeni);

            i = i + 1;
          });
        }
      }
    },
    search: {
      handler: function (val, oldVal) {
        if (event != undefined) {
          this.UlkeCek(val, event.target.name);
        }
      },
      deep: true,
    },
    search1(val) {
      // val && this.UlkeCek(val)
    },
  },
  components: {
    tarihim,
    loadingcomp,
    snackbarcomp,
    caricomp,
    yetkidialog,
    hotelloadingcomp,
    tanitimMail,
    parainputevents,
    parainput,
    phoneinput,
    adresaradialogcustom
  },
};

function beforeMount() {
  // this.login();
}

function UlkeCek(val, id) {
  var bookingParams = JSON.parse(
    window.localStorage.getItem("transferBookingParams")
  );
  var params = {
    SessionHeader: {
      SessionId: bookingParams.SessionId,
      SessionToken: bookingParams.SessionToken
    },
    // SearchText: val[id],
    // Language: "TR",
    Country: {
      Id: 0,
      CountryCode: "",
      CountryName: val[id]
    },
    ArkmanCountryId: 0
  };




  if (val.length >= 1) {
    setTimeout(() => {
      this.$http
        .post(auth.PAXDRIVE_API_URL + "Map/GetCountryList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            var country = {
              countrycode: 'TR',
              countryName: 'TR'
            };
            // this.ulkeitems[id] = response.body;
            this.ulkeItems[id].push(country);

          },
          (response) => {
            this.text1 = this.$t('An-error-has-occurred-during-country-search')
            this.snackbar = true;
            this.progress = false;
          }
        );
    }, 500);
  }
}

function TransferKaydet() {
  this.UpdatePassengers();
  return;
  if (this.$refs.formtransfer.validate()) {
    this.loadingmesaj = this.$t('Your-process-being-completed');
    this.loadingdialog = true;

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

    var params = {
      LogInput: {
        UserID: credentials.UserID,
        CustomerID: credentials.MusteriID,
      },
      ReferenceNumber: this.TransferResult.ReferenceNumber,
      FlightNumber: this.TransferData.FlightNumber, //PickupPointId
      Adress: this.TransferData.Adress, //DropPointId
      PickupPointName: this.TransferResult.PickupPointName,
      DropPointName: this.TransferResult.DropPointName,
      Nationality: 'TR',//this.kisiBilgileri[0].Ulke, //
      IdNo: this.kisiBilgileri[0].TcKimlikNo, //
      Name: this.kisiBilgileri[0].Ad, //
      LastName: this.kisiBilgileri[0].Soyad, //
      Email: this.TransferData.Email, //
      Phone: this.TransferData.Phone, //
      DropPointInfo: this.TransferData.DropPointInfo, //bırakılacak yer açıklam
      PickupPointInfo: this.TransferData.PickupPointInfo, // alınacak yer açıklama
      BookingInfo: this.TransferData.BookingInfo, //rezervasyon bilgisi
      PaxAdult: this.getPersonInfo(0),
      PaxChild: this.getPersonInfo(1),
      PaxBaby: this.getPersonInfo(2),
    };

    this.$http
      .post(auth.PAXDRIVE_API_URL + "api/Transfer/GetPrebooking", params, {
        headers: {
          Authorization:
            "Basic " +
            window.btoa(
              auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
            ),
        },
      })
      .then(
        (response) => {
          if (response.body.Status == true) {
            if (this.islemTipi == "pdyeni") {
              var transfer = {
                TransferData: this.TransferData,
                PaxDrive: this.TransferResult,
                AdresBilgileri: this.kisiBilgileri,
                pdislem: true,
                pdislemTipi: this.islemTipi,
                CariKodu: this.cariKod,
                SaticiBilgileri: this.getSaticiBilgileri(),
                CardId: response.body.CardId,
                Pnr: response.body.Pnr,
              };

              window.localStorage.setItem(
                "pdtransfer",
                JSON.stringify(transfer)
              );
              this.loadingmesaj = this.$t('Process-completed-being-redirected-reservation-page-registration');

              setTimeout(
                function () {
                  this.loadingdialog = false;
                  var link = "#/coper/rezervasyon/index/id?islem=pdyeni";
                  window.open(link, "_target");
                }.bind(this),
                5000
              );
            } else if (this.islemTipi == "pdget") {
              var pdrive = JSON.parse(
                window.localStorage.getItem("pdtransfer")
              );
              var adres = null;

              var transfer = {
                Rezervasyon: pdrive.Rezervasyon,
                TransferData: this.TransferData,
                AdresBilgileri: this.kisiBilgileri,
                PaxDrive: this.TransferResult,
                pdislem: true,
                pdislemTipi: this.islemTipi,
                SaticiBilgileri: this.getSaticiBilgileri(),
                CardId: response.body.CardId,
                Pnr: response.body.Pnr,
              };

              window.localStorage.setItem(
                "pdtransfer",
                JSON.stringify(transfer)
              );

              this.loadingmesaj = this.$t('Process-completed-being-redirected-reservation-page-registration');

              setTimeout(function () {
                this.loadingdialog = false;
                var link = "#/coper/rezervasyon/index/id?islem=pdget";
                window.open(link, "_target");
              });
            }
          } else {
            this.loadingdialog = false;
            this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = this.$t("error-occurred-please-try-again");
          this.snackbar = true;
          this.loadingdialog = false;
        }
      );
  }
}
</script>

<style scoped>
/* Header */
.page-header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 20px 24px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

/* Cards */
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.purple-bar {
  border-top-color: #667eea;
  background: #fafafa;
}

.card-header.green-bar {
  border-top-color: #10b981;
  background: #fafafa;
}

.card-header.amber-bar {
  border-top-color: #f59e0b;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}

.pax-number-badge {
  width: 28px;
  height: 28px;
  background: #667eea;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sticky-sidebar {
  position: sticky;
  top: 16px;
}
</style>